import React, {
  createContext,
  useMemo,
  useCallback,
  ReactNode,
  useState,
  useEffect,
} from 'react';

type LanguageContextProps = {
  currentLanguage: string;
  setLanguage: (language: string) => void;
};

export const LanguageContext = createContext<LanguageContextProps>({
  currentLanguage: 'en',
  setLanguage: () => {},
});

export const LanguageProvider = ({ children }: { children: ReactNode }) => {
  const [currentLanguage, setCurrentLanguage] = useState<string>('en');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('lng');

    if (savedLanguage) {
      setCurrentLanguage(savedLanguage);
    }
  }, []);

  const setLanguage = useCallback((language: string) => {
    setCurrentLanguage(language);
  }, []);

  const value = useMemo(
    () => ({ currentLanguage, setLanguage }),
    [currentLanguage, setLanguage],
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
